module.exports = __webpack_public_path__ + "img/cloud-upload.0390c3b7.svg";